import CollapseIcon from "@entrilia/shared/icons/CollapseIcon";
import ExpandIcon from "@entrilia/shared/icons/ExpandIcon";
import { Box, ButtonBase, Collapse, MenuList, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  title: string;
  expanded: boolean;
  toggleDisabled: boolean;
  onToggle: () => void;
}

const ChatGroupSection = ({ title, expanded, toggleDisabled, onToggle, children }: PropsWithChildren<Props>) => (
  <Box sx={{ pl: 1 }}>
    <ButtonBase
      focusRipple
      aria-expanded={expanded}
      disabled={toggleDisabled}
      onClick={onToggle}
      sx={{ width: "100%", justifyContent: "flex-start", gap: 0.5 }}
    >
      <Typography variant="subtitle2" component="span">
        {title}
      </Typography>
      {!toggleDisabled && (expanded ? <CollapseIcon /> : <ExpandIcon />)}
    </ButtonBase>
    <Collapse in={expanded} timeout="auto">
      <MenuList>{children}</MenuList>
    </Collapse>
  </Box>
);

export default ChatGroupSection;
